export const MessageTableHeaders = ["message-title", "language", "modify"];
